import { render, staticRenderFns } from "./VaultMembers.vue?vue&type=template&id=18f316cc"
import script from "./VaultMembers.vue?vue&type=script&lang=js"
export * from "./VaultMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports